module.exports = __webpack_public_path__ + "img/rider.1e1c3324.svg";